import React from "react";
import './Home.css'
import github from '../Images/github.png'
import linkedin from '../Images/linkedin.png'
import bewerbung from '../Images/Bewerbungsfoto.jpg'



function importAllImages(r) {
    return r.keys().map( (key) => ( {
        name: key.replace('.', '').replace(/\.\w+$/, ''),
        image: r(key),
    }));
}

const skills = importAllImages(require.context('../Images/Languages', false, /\.(png|jpe?g|svg)$/))
export function Home() {
    return(
    <>
    <div className="home-page">
        <div className="home-text-image">
            <div className="home-text">
                <small> Hello I am Alex,</small>
                <b> Software </b>
                <b className="colored"> Developer </b>
                <small> based in Germany.</small>
                <div className="home-links">
                    <a href="https://github.com/wardell00">
                        <img src={github} alt='github' className='links-profiles'/>
                    </a>
                    <a href="https://www.linkedin.com/in/alexander-löwe-49a264269/">
                        <img src={linkedin} alt='linkedin' className='links-profiles'/>
                 </a>
                </div>
            </div>
            <img src={bewerbung} alt='profile' className='profile'/>
        </div>
        <div className="Skills">
            <h2>Skills</h2>
            <div>
                {
                    skills.map( (skill, index) => (
                        <img src={skill.image} alt={skill.name} className="skill-image"/>
                    ))
                }
            </div>
        </div>
        
    </div>
    </>
    )
}